// Autogenerated file
export const orderPriceTypesEnum = {
    Unknown: "Unknown",
    Static: "Static",
    Auction: "Auction",
    Offer: "Offer",
};
export const orderPriceTypes = [
    { label: "Фиксированная цена", value: "Unknown" },
    { label: "Фиксированная цена", value: "Static" },
    { label: "Аукцион", value: "Auction" },
    { label: "Предложенная цена", value: "Offer" },
];
